export const CREATE_USER = "CREATE_USER";
export const API_ERROR = "API_ERROR";
export const RESET_API_ERROR = "RESET_API_ERROR";
export const API_NOTIFICATION_MSG = "API_NOTIFICATION_MSG";
export const RESET_NOTIFICATION_MSG = "RESET_NOTIFICATION_MSG";
export const HOME_PAGE_SECTION_DATA = "HOME_PAGE_SECTION_DATA";
